const Advertisement = ({ text }) => (
  <div className="p-0 mb-3 me-3 text-gray not-loading">
    <p className="text-danger text-sm mt-4">
      {text}
    </p>
  </div>
)

export default Advertisement
